import React from 'react'

const Highlight = ({children, style}) => (
  <span className="highlight" style={style}>{children}</span>
)

export default Highlight
